import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { createMobileProjectAction } from 'actions/projectActions'
import { notificationAction } from 'actions/notificationActions'
import toLatLngLiteral from 'helpers/map/toLatLngLiteral'

class LocationSearch extends React.Component {
  state = { loading: false }

  componentDidMount() {
    const { refs: { input }, props: { createMobileProjectAction, notificationAction } } = this
      
    const autocomplete = new google.maps.places.Autocomplete(input)
    autocomplete.setFields(['adr_address', 'geometry'])

    google.maps.event.addListener(autocomplete, 'place_changed', (function() {
      const place = autocomplete.getPlace()
      if (!place.geometry) {
        notificationAction('Location data not found')
        this.setState({ loading: false })
      } else {
        this.setState({ loading: true })
        if ((/street-address/g).test(place.adr_address)) {
          createMobileProjectAction(toLatLngLiteral(place.geometry.location), 19)
        } else {
          createMobileProjectAction(toLatLngLiteral(place.geometry.viewport.getCenter()), 12)
        }
      }
    }).bind(this))

    this.autocomplete = autocomplete
  }

  componentWillUnmount() {
    google.maps.event.clearInstanceListeners(this.autocomplete)
  }

  render() {
    const { state: { loading }, props: { classes } } = this

    return (
      <div className={classes.container}>
        <div className={classes.header}>
          Enter Project Address
        </div>
        <div className={classes.searchWrapper}>
          <input type='search' placeholder='Enter a location' ref='input' className={classes.searchInput} />
          <FontAwesomeIcon icon='search' className={classes.searchIcon} />
        </div>
        {
          loading &&
          <div className={classes.loading}>
            <FontAwesomeIcon icon='spinner' className={`${classes.loadingButton} fa-spin`} />
            Creating Project...
          </div>
        }
      </div>
    )
  }
}

export default connect(null, { createMobileProjectAction, notificationAction })(injectSheet(style)(LocationSearch))



// WEBPACK FOOTER //
// ./src/components/MobileStart/LocationSearch/index.js